module.exports = __webpack_public_path__ + "img/bosscenter.832341c6.png";